import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock } from 'lucide-react';

const STATUS_COLORS = {
  'New Bank': { bg: 'bg-sky-500', ring: 'ring-sky-100', text: 'text-sky-700' },
  'In Process': { bg: 'bg-amber-500', ring: 'ring-amber-100', text: 'text-amber-700' },
  'Unassigned': { bg: 'bg-teal-500', ring: 'ring-teal-100', text: 'text-teal-700' },
  'Active': { bg: 'bg-green-500', ring: 'ring-green-100', text: 'text-green-700' },
  'Inactive': { bg: 'bg-slate-400', ring: 'ring-slate-100', text: 'text-slate-600' },
  'Freezed - Transaction': { bg: 'bg-red-500', ring: 'ring-red-100', text: 'text-red-700' },
  'Freezed - CBI': { bg: 'bg-red-500', ring: 'ring-red-100', text: 'text-red-700' },
  'Closed': { bg: 'bg-purple-500', ring: 'ring-purple-100', text: 'text-purple-700' },
};

const formatDate = (ts) => {
  try {
    const d = new Date(ts);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) + ' ' + d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  } catch { return ts; }
};

export const StatusTimeline = ({ statusHistory }) => {
  if (!statusHistory || statusHistory.length === 0) return null;

  return (
    <Card className="p-4 space-y-3" data-testid="status-timeline">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-slate-500" />
        <h3 className="font-semibold text-sm text-slate-700">Status Timeline</h3>
      </div>
      <div className="relative ml-3">
        <div className="absolute left-[7px] top-2 bottom-2 w-0.5 bg-slate-200" />
        <div className="space-y-4">
          {statusHistory.map((entry, idx) => {
            const colors = STATUS_COLORS[entry.status] || { bg: 'bg-slate-400', ring: 'ring-slate-100', text: 'text-slate-600' };
            const isLatest = idx === statusHistory.length - 1;
            return (
              <div key={`${entry.status}-${entry.timestamp}`} className="relative flex items-start gap-3 pl-0" data-testid={`timeline-entry-${idx}`}>
                <div className={`relative z-10 w-4 h-4 rounded-full ${colors.bg} ${isLatest ? 'ring-4 ' + colors.ring : ''} flex-shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`font-semibold text-sm ${colors.text}`}>{entry.status}</span>
                    {isLatest && <Badge className="bg-slate-100 text-slate-600 text-[10px] px-1.5 py-0">Current</Badge>}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    {formatDate(entry.timestamp)}
                    {entry.changedBy && <span className="ml-1.5 text-slate-400">by {entry.changedBy}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};
